import { TFunction } from "i18next";
import { useDispatch } from "react-redux";

import { AppDispatch } from "../../../../../redux/store";
import {
    setIsLoading,
    setIsAssociateModalOpened,
    setIsAssociateModalClosed,
    setKey,
} from "../../../../../redux/slices/fidelitySlice";
import { runAssociateFidelity } from "../helpers";

type Deps = {
    userID: number;
    franchiseID: string;
    operatorID: string;
    shopID: string;
    uuidUser: string | null;
    localShop: string[];
    rowsShop: any[];
    selectedRowsFidelity: any;
    activeFidelity: any[];
    fidelity: string;
    isAssociateModalClosed: boolean;
    fetchGlobal: FetchGlobal;
    t: TFunction;
    setLimit: (v: number) => void;
    setIsValidateButtonEnabled: (v: boolean) => void;
};

export function useRunAssociate(deps: Deps) {
    const dispatch = useDispatch<AppDispatch>();
    return () =>
        runAssociateFidelity({
            ...deps,
            setLimit: deps.setLimit as (v: number) => void,
            setIsValidateButtonEnabled: deps.setIsValidateButtonEnabled as (
                v: boolean
            ) => void,
            setIsLoading: (v: boolean) => dispatch(setIsLoading(v)),
            setIsAssociateModalOpened: (v: boolean) =>
                dispatch(setIsAssociateModalOpened(v)),
            setIsAssociateModalClosed: (v: boolean) =>
                dispatch(setIsAssociateModalClosed(v)),
            setKey: (v: string) => dispatch(setKey(v)),
        });
}
